module.exports = __webpack_public_path__ + "img/accueil-evenements-thumbnail.f8ea9b6f.jpg";